import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { resolveUploadUrl } from '../config/api';
import { useLanguage } from '../context/LanguageContext';
import './NewsDetail.css';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, locale, language } = useLanguage();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNews();
  }, [id, language]);

  const fetchNews = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/news/${id}`, { params: { lang: language } });
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching news:', error);
      setError(t('newsDetail.notFound'));
    } finally {
      setLoading(false);
    }
  };

  // Function to decode HTML entities
  const decodeHtmlEntities = (text) => {
    if (!text) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  };

  if (loading) {
    return (
      <div className="news-detail-page">
        <div className="news-detail-container">
          <div className="loading">{t('newsDetail.loading')}</div>
        </div>
      </div>
    );
  }

  if (error || !news) {
    return (
      <div className="news-detail-page">
        <div className="news-detail-container">
          <div className="error-message">
            <h2>{t('newsDetail.notFound')}</h2>
            <button type="button" onClick={() => navigate('/')} className="btn-back">
              {t('newsDetail.backHome')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  const cleanTitle = decodeHtmlEntities(news.title);
  const cleanContent = news.content;

  return (
    <div className="news-detail-page">
      <div className="news-detail-container">
        <button type="button" onClick={() => navigate(-1)} className="btn-back">
          {t('newsDetail.back')}
        </button>

        <article className="news-article">
          {news.imageUrl && (
            <div className="news-detail-image">
              <img 
                src={news.imageUrl.startsWith('http') ? news.imageUrl : resolveUploadUrl(news.imageUrl)} 
                alt={cleanTitle} 
              />
            </div>
          )}

          <div className="news-detail-header">
            <h1>{cleanTitle}</h1>
            <div className="news-meta">
              <span className="news-date">
                {new Date(news.createdAt).toLocaleDateString(locale, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
            </div>
          </div>

          <div 
            className="news-detail-content"
            dangerouslySetInnerHTML={{ __html: cleanContent }}
          />
        </article>
      </div>
    </div>
  );
};

export default NewsDetail;

